module.exports = __webpack_public_path__ + "img/hr-dark-mud-decal-24.30fb4167.png";